<p-panel header="Services" [toggleable]="true">
  <div class="order-line-sticky-header p-2 gap-2">
    <div class="align-items-center d-flex col-lg-12 mb-3">
      <div class="nav-link p-0 d-flex align-items-center">
        <a class="link" (click)="addNewService()"
          ><i class="pi pi-plus"></i> New</a
        >
      </div>

      <div class="ms-3 nav-link p-0 d-flex align-items-center delete">
        <div>
          <a class="link delcol" (click)="onDeleteLines()"
            ><i class="pi pi-trash"></i> Delete</a
          >
        </div>
      </div>
      <div class="ms-3 nav-link p-0 d-flex align-items-center">
        <a class="link" (click)="onCopyLines()"
          ><i class="pi pi-copy"></i> Copy Lines</a
        >
      </div>
      <!-- <div
        class="ms-3 nav-link p-0 d-flex align-items-center"
        *ngIf="selectedServiceLines && selectedServiceLines.length"
      >
        <a class="link" (click)="addressAssignment()">Address Assignment</a>
      </div> -->
    </div>
    <div class="indropdowntable col-lg-12 fixTableHead table-hgt">
      <p-table
        #dt
        stripedRows
        [rowHover]="true"
        [showCurrentPageReport]="true"
        [scrollable]="true"
        scrollHeight="350px"
        [size]="'small'"
        [resizableColumns]="true"
        [value]="filteredServiceLines"
        [(selection)]="selectedServiceLines"
        styleClass="p-datatable-customers ordersLineItems no-wrap table-hover-bg"
        [rowHover]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [paginator]="false"
        [filterDelay]="0"
        dataKey="portalKeyD365"
        editMode="row"
        selectionMode="multiple"
        [scrollable]="true"
        scrollHeight="310px"
        columnResizeMode="expand"
        styleClass="table-listing">
        <ng-template pTemplate="header">
          <tr class="table-head">
            <th class="colwdth-small"></th>
            <th class="colwdth-small">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th class="name">Item number</th>
            <th class="purpose">External Item Id</th>
            <th class="purpose colwdth-large width-250">Description</th>
            <th class="email">Ship date</th>
            <th class="save">In-hands date</th>
            <th class="save">Shipping Method</th>
            <th class="save">Account</th>
            <th class="exist colwdth-large">Factory Notes</th>
            <th class="confirmation">Product name</th>
            <th class="Invoice">Vendor</th>
            <th class="Invoice">Vendor name</th>
            <th class="Invoice">Quantity</th>
            <th class="Invoice">Unit</th>
            <th class="Invoice">Unit price</th>
            <th class="Invoice">Currency</th>
            <th class="Invoice">Amount</th>
            <!-- <th class="Invoice">Price in transaction currency</th>
            <th class="Invoice">Amount in transaction currency</th> -->
            <th class="Invoice">Delivery selection</th>
            <th class="Invoice cell-left">Address name/description</th>
            <th class="Invoice cell-left">Ship-to address</th>
            <th class="Invoice">Final PO</th>
            <th class="Invoice">Excluded</th>
          </tr>
        </ng-template>
        <ng-template
          pTemplate="body"
          let-serviceLine
          let-editing="editing"
          let-ri="rowIndex">
          <ng-container>
            <tr
              class="p-selectable-row"
              [pSelectableRow]="serviceLine"
              [pEditableRow]="serviceLine">
              <td class="colwdth-small">
                <button
                  *ngIf="!editing"
                  pButton
                  pRipple
                  type="button"
                  (click)="redirectToServicesForm(serviceLine)"
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-text"></button>
                <button
                  *ngIf="editing"
                  pButton
                  pRipple
                  type="button"
                  pSaveEditableRow
                  icon="pi pi-check"
                  class="p-button-rounded p-button-text p-button-success p-mr-2"
                  (click)="onRowEditSave(serviceLine)"></button>
                <button
                  *ngIf="editing"
                  pButton
                  pRipple
                  type="button"
                  pCancelEditableRow
                  icon="pi pi-times"
                  class="p-button-rounded p-button-text p-button-danger"></button>
              </td>
              <td class="colwdth-small">
                <p-tableCheckbox
                  [value]="serviceLine"
                  [pEditableRow]="serviceLine"
                  [pSelectableRow]="serviceLine"></p-tableCheckbox>
              </td>
              <td
                class="d-holder drop-holder"
                style="position: relative"
                pEditableColumn
                pEditableColumnField="itemNumberD365">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-select
                      [editable]="editing ? false : true"
                      dropdownPosition="bottom"
                      class="invoiceemaildropdown"
                      (onChange)="itemSelected($event, serviceLine)"
                      [(ngModel)]="serviceLine.itemNumberD365"
                      appendTo="body"
                      [options]="items"
                      optionLabel="itemNumberD365"
                      optionValue="itemNumberD365"
                      [filter]="true"
                      [showClear]="true">
                    </p-select>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ serviceLine.itemNumberD365 }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td
                class="externalItemId"
                pEditableColumn
                pEditableColumnField="externalItemNumberD365">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      [(ngModel)]="serviceLine.externalItemNumberD365"
                      (keydown)="
                        onTextFieldKeyDown(
                          $event,
                          serviceLine,
                          'externalItemNumberD365'
                        )
                      " />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ serviceLine.externalItemNumberD365 }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td
                class="description colwdth-large cell-left hoverwdth"
                style="white-space: normal !important"
                [ngClass]="{
                  'trimmeddescription trimmedby50char':
                    descriptionCharacterCond,
                }"
                pEditableColumn
                pEditableColumnField="lineDescriptionD365"
                pTooltip="{{ serviceLine.lineDescriptionD365 }}"
                [tooltipOptions]="toolTipOptions">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <textarea
                      style="height: auto; max-height: 150px; width: 100%"
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      [(ngModel)]="serviceLine.lineDescriptionD365"
                      (keydown)="
                        onTextFieldKeyDown(
                          $event,
                          serviceLine,
                          'lineDescriptionD365'
                        )
                      "></textarea>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{
                      descriptionCharacterCount(serviceLine.lineDescriptionD365)
                    }}
                    {{ serviceLine.lineDescriptionD365 }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td
                class="number"
                pEditableColumn
                pEditableColumnField="requestedShippingDateD365">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-datepicker
                      jniAutoCompleteBlocker
                      #sdp
                      [name]="'shipDate-' + ri"
                      [id]="'shipDate-' + ri"
                      appendTo="body"
                      class="date-input"
                      [(ngModel)]="serviceLine.requestedShippingDateD365"
                      (onSelect)="shipDateChange($event, serviceLine)"
                      [minDate]="shipDateCurrentdate"
                      (onClear)="
                        clearDateField(serviceLine, 'requestedShippingDateD365')
                      "
                      (onInput)="
                        handleKeyDown(
                          $event,
                          sdp,
                          serviceLine,
                          'requestedShippingDateD365'
                        )
                      "
                      (onClose)="refocusById('shipDate-' + ri)"
                      [inputId]="'shipDate-' + ri"
                      showOnFocus="false"
                      showIcon="true"
                      iconDisplay="input"
                      [showClear]="true"
                      [selectOtherMonths]="true"></p-datepicker>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <span
                      *ngIf="
                        serviceLine?.requestedShippingDateD365
                          | hidedynamicsdate
                      ">
                      {{
                        serviceLine?.requestedShippingDateD365
                          | date: "MM/dd/yyyy"
                      }}
                    </span>
                  </ng-template>
                </p-cellEditor>
              </td>
              <td
                class="number"
                pEditableColumn
                pEditableColumnField="requestedDeliveryDateD365">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-datepicker
                      jniAutoCompleteBlocker
                      #ddp
                      [inputId]="'deliveryDate-' + ri"
                      [id]="'deliveryDate-' + ri"
                      appendTo="body"
                      class="date-input"
                      [name]="'deliveryDate-' + ri"
                      (onSelect)="deliveryDateChange($event, serviceLine)"
                      (onClose)="refocusById('deliveryDate-' + ri)"
                      [(ngModel)]="serviceLine.requestedDeliveryDateD365"
                      [minDate]="shipDateCurrentdate"
                      (onClear)="
                        clearDateField(serviceLine, 'requestedDeliveryDateD365')
                      "
                      (onInput)="
                        handleKeyDown(
                          $event,
                          ddp,
                          serviceLine,
                          'requestedDeliveryDateD365'
                        )
                      "
                      showOnFocus="false"
                      showIcon="true"
                      iconDisplay="input"
                      [showClear]="true"
                      [selectOtherMonths]="true"
                      [dateFormat]="'mm/dd/yy'"></p-datepicker>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <span
                      *ngIf="
                        serviceLine?.requestedDeliveryDateD365
                          | hidedynamicsdate
                      ">
                      {{
                        serviceLine?.requestedDeliveryDateD365
                          | date: "MM/dd/yyyy"
                      }}
                    </span>
                  </ng-template>
                </p-cellEditor>
              </td>
              <td
                class="d-holder drop-holder"
                style="position: relative"
                pEditableColumn
                pEditableColumnField="deliveryModeIdD365">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-select
                      [editable]="editing ? false : true"
                      dropdownPosition="bottom"
                      class="invoiceemaildropdown"
                      (onClear)="clearShippingMethod(serviceLine)"
                      (onChange)="onShippingMethodSelect($event, serviceLine)"
                      [(ngModel)]="serviceLine.deliveryModeIdD365"
                      appendTo="body"
                      [options]="shippingProductsList"
                      optionLabel="modeDescriptionD365"
                      optionValue="modeCodeD365"
                      [filter]="true"
                      [showClear]="true">
                    </p-select>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ serviceLine.deliveryModeIdD365 }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td
                class="cell-left"
                pEditableColumn
                pEditableColumnField="freightAccountNumD365">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      [(ngModel)]="serviceLine.freightAccountNumD365" />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ serviceLine.freightAccountNumD365 }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td
                class="description colwdth-large cell-left hoverwdth"
                [ngClass]="{
                  'trimmeddescription trimmedby50char':
                    descriptionCharacterCond,
                }"
                pEditableColumn
                pEditableColumnField="factoryNotesD365"
                [pTooltip]="serviceLine.factoryNotesD365"
                [tooltipOptions]="toolTipOptions">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <textarea
                      style="height: auto; max-height: 150px; width: 100%"
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      [(ngModel)]="serviceLine.factoryNotesD365"
                      (keydown)="
                        onTextFieldKeyDown(
                          $event,
                          serviceLine,
                          'factoryNotesD365'
                        )
                      "></textarea>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ serviceLine.factoryNotesD365 }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td class="cell-left">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      [(ngModel)]="serviceLine.productName"
                      disabled />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ serviceLine.productName }}
                  </ng-template>
                </p-cellEditor>
              </td>

              <td
                class="quantity cell-left"
                pEditableColumn
                pEditableColumnField="vendorIdD365">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <div>
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        #VendorAccInput
                        type="text"
                        id="vendoraccount"
                        name="vendoraccount"
                        class="form-control vendor-wdth"
                        [value]="vendorAccountNumber"
                        [(ngModel)]="serviceLine.vendorIdD365"
                        (input)="searchVendor$.next($any($event.target).value)"
                        (keyup)="
                          onVendorSearchOpenToggle(
                            vendorIPDropdown,
                            $event,
                            VendorAccInput
                          )
                        "
                        (focus)="selectText($event)"
                        #mydropVendor />
                      <p-popover class="order-dropdown" #vendorIPDropdown>
                        <div class="indropdowntable" style="height: 310px">
                          <p-table
                            #dt
                            [value]="vendorList"
                            styleClass="p-datatable-customers order-listing"
                            [rowHover]="true"
                            [rows]="10"
                            [showCurrentPageReport]="true"
                            [rowsPerPageOptions]="[10, 25, 50]"
                            [paginator]="false"
                            [filterDelay]="0">
                            <ng-template pTemplate="header">
                              <tr>
                                <th class="name">Name</th>
                                <th class="vaccount">3PL</th>
                                <th class="currency">Currency</th>
                                <th class="sname">Search name</th>
                                <th class="phone">Phone</th>
                                <th class="city">City</th>
                                <th class="state">State</th>
                                <th class="country">Country</th>
                              </tr>
                            </ng-template>
                            <ng-template
                              pTemplate="body"
                              let-vendorList
                              let-rowIndex="rowIndex">
                              <tr
                                class="p-selectable-row mousepointer"
                                (click)="
                                  onVendorRowSelection(
                                    vendorList,
                                    vendorIPDropdown,
                                    serviceLine
                                  )
                                ">
                                <td class="name mousepointer">
                                  {{ vendorList.vendorName }}
                                </td>
                                <td class="vaccount mousepointer">
                                  {{ vendorList.vendorAccountNumber }}
                                </td>
                                <td class="sname mousepointer">
                                  {{ vendorList.currency }}
                                </td>
                                <td class="sname mousepointer">
                                  {{ vendorList.vendorSearchName }}
                                </td>
                                <td class="phone mousepointer">
                                  {{ vendorList.phoneNumber }}
                                </td>
                                <td class="city mousepointer">
                                  {{ vendorList.city }}
                                </td>
                                <td class="state mousepointer">
                                  {{ vendorList.state }}
                                </td>
                                <td class="country mousepointer">
                                  {{ vendorList.country }}
                                </td>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                              <tr>
                                <td colspan="20">No vendor found.</td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </div>
                      </p-popover>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ serviceLine.vendorIdD365 }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td class="quantity cell-left">
                {{ serviceLine.vendorNameD365 }}
              </td>

              <td
                class="quantity cell-right"
                pEditableColumn
                pEditableColumnField="orderedPurchaseQuantityD365">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      [(ngModel)]="serviceLine.orderedPurchaseQuantityD365"
                      (keydown)="onQuantityKeyDown($event, serviceLine)"
                      (onChange)="
                        calculateQuantity(
                          serviceLine.orderedPurchaseQuantityD365,
                          serviceLine
                        )
                      "
                      (focus)="selectText($event)"
                      required />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ serviceLine.orderedPurchaseQuantityD365 }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td pEditableColumn pEditableColumnField="purchaseUnitSymbolD365">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-select
                      dropdownPosition="bottom"
                      class="invoiceemaildropdown"
                      [editable]="editing ? false : true"
                      [ngModelOptions]="{ standalone: true }"
                      [(ngModel)]="serviceLine.purchaseUnitSymbolD365"
                      appendTo="body"
                      [options]="unit"
                      [filter]="true"
                      [showClear]="true"
                      >]
                    </p-select>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ serviceLine.purchaseUnitSymbolD365 }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td
                class="quantity cell-right"
                pEditableColumn
                pEditableColumnField="purchasePriceD365">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      [(ngModel)]="serviceLine.purchasePriceD365"
                      (keydown)="onUnitPriceKeyDown($event, serviceLine)"
                      (focusout)="
                        onNetConversion(
                          serviceLine.purchasePriceD365,
                          serviceLine
                        )
                      "
                      (focus)="selectText($event)"
                      required />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{
                      serviceLine.purchasePriceD365
                        | currency
                          : getCurrencyConvertionCode(
                              serviceLine?.currencyCodeD365 || ""
                            )
                          : "symbol"
                          : "0.4-4"
                    }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td class="d-holder">
                {{ serviceLine.currencyCodeD365 }}
              </td>
              <td class="ntotal cell-right">
                {{
                  serviceLine.lineAmountD365
                    | currency
                      : getCurrencyConvertionCode(
                          serviceLine?.currencyCodeD365 || ""
                        )
                      : "symbol"
                      : "0.2-2"
                }}
              </td>
              <!-- <td class="ntotal cell-right">
                {{
                  serviceLine.priceInTransactionCurrency
                    | currency: 'USD':'symbol':'0.2-2'
                }}
              </td>
              <td class="ntotal cell-right">
                {{
                  serviceLine.amountInTransactionCurrency
                    | currency: 'USD':'symbol':'0.2-2'
                }}
              </td> -->
              <td class="quantity">
                {{ serviceLine.deliverySelectionD365 }}
              </td>
              <td class="quantity cell-left">
                {{ serviceLine.addressDescriptionD365 }}
              </td>
              <td class="quantity cell-left">
                {{ serviceLine.shipToAddressD365 }}
              </td>
              <td class="bul-center">
                <p-checkbox
                  id="finalPo"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="serviceLine.finalPoD365"
                  inputId="finalPo"
                  class="d-flex justify-content-center"
                  [binary]="true"></p-checkbox>
              </td>
              <td class="bul-center">
                <p-checkbox
                  id="excluded"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="serviceLine.excludedD365"
                  class="d-flex justify-content-center"
                  inputId="excluded"
                  [binary]="true"></p-checkbox>
              </td>
            </tr>
          </ng-container>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="20" class="colwdth-large nofound">
              No line item found.
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="20" class="colwdth-large nofound">
              No line item found.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-panel>

<jni-address-assignment
  [(display)]="displayAddressAssignment"
  [headerObject]="purchaseOrderHeader"
  [addressObject]="purchaseOrderHeaderAddress"
  (saveEmit)="onAddressAssignment($event)"
  *ngIf="displayAddressAssignment"></jni-address-assignment>
